<template>
  <BasicWrapper white>
    <h2 class="text-center textHeadline2 mb-5">
      {{ $t("profile.about.dataprivacy.item.title") }}
    </h2>
    <div class="textBody1" v-html="$t('data.privacy')"></div>
    <button class="button-bkk-100 mt-4" @click="cookieConsentOpen = true">
      {{ $t("cookie.consent.customize.settings") }}
    </button>
    <CookieConsent
      v-if="cookieConsentOpen"
      force-open="true"
      @on-save-settings="cookieConsentOpen = false"
    />
  </BasicWrapper>
</template>

<script>
import BasicWrapper from "../../components/v2/layout/pageWrapper/BasicWrapper.vue";
import CookieConsent from "../../components/v2/layout/CookieConsent.vue";

export default {
  name: "PrivacyFallbackPage",
  components: { CookieConsent, BasicWrapper },
  data() {
    return {
      cookieConsentOpen: false,
    };
  },
};
</script>
